import dayjs from 'dayjs';

import { SettingsGroup, SettingsGroupItem } from '@sb/design-system';
import type { RestoreCheckpointSummary } from '@sb/feathers-types';

interface RestoreCheckpointPanelProps {
  checkpoint: RestoreCheckpointSummary;
}

interface RestoreCheckpointRowProps {
  label: string;
  value: string;
  'data-testid': string;
}

function RestoreCheckpointRow({
  label,
  value,
  'data-testid': dataTestId,
}: RestoreCheckpointRowProps) {
  return (
    <SettingsGroupItem>
      <span className="tw-flex-1">{label}</span>
      <span
        className="tw-text-label-secondary tw-truncate"
        data-testid={dataTestId}
        title={value}
      >
        {value}
      </span>
    </SettingsGroupItem>
  );
}

/** What is about to be written over this robot: the backup's own identity,
 *  the equivalent of the software-update screen's "installed version". */
export function RestoreCheckpointPanel({
  checkpoint,
}: RestoreCheckpointPanelProps) {
  const created = checkpoint.createdAt
    ? dayjs(checkpoint.createdAt).format('MMM D, YYYY h:mm A')
    : 'Unknown';

  return (
    <section
      className="tw-flex tw-flex-col"
      data-testid="restore-confirmation-checkpoint-region"
    >
      <h5 className="tw-heading-40 tw-pl-16">Backup to restore</h5>

      <SettingsGroup>
        <RestoreCheckpointRow
          label="Name"
          value={checkpoint.label || checkpoint.backupKey}
          data-testid="restore-confirmation-checkpoint-name"
        />
        <RestoreCheckpointRow
          label="Taken"
          value={created}
          data-testid="restore-confirmation-checkpoint-created"
        />
        <RestoreCheckpointRow
          label="From robot"
          value={checkpoint.robotId}
          data-testid="restore-confirmation-checkpoint-robot"
        />
      </SettingsGroup>
    </section>
  );
}
